export default {
      id: "Icon--mapLayers-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--mapLayers",
      toString: function () {
        return this.url;
      }
    }